const PERMISSION_KEY= "personalize:watchlist_item";
const PAGE_URL = {
    WATCHLIST_ITEM_PAGE: "/admin/personalize/watchlist-item"
}

export {PERMISSION_KEY, PAGE_URL}

